module.exports = __webpack_public_path__ + "img/snapchat.2899658e.svg";